import script from "./MTB_Config.vue?vue&type=script&setup=true&lang=js"
export * from "./MTB_Config.vue?vue&type=script&setup=true&lang=js"

import "./MTB_Config.vue?vue&type=style&index=0&id=2a24a2d3&lang=css"
import "./MTB_Config.vue?vue&type=style&index=1&id=2a24a2d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a24a2d3"]])

export default __exports__